import { iaRa } from 'lib/helpers/utility';

import { clinicalNote as clinicalNoteState, userState as user_state } from 'components/state';

const { useDocumentSign } = require('lib/hooks/queries/documentSign/useDocumentSign');
const { useState, useEffect } = require('react');
const { useRecoilValue } = require('recoil');

const useClinicalNoteSignatures = ({ setDocumentSignInfo, saveButtonText }) => {
  const [userSign, setUserSign] = useState(false);
  const clinicalNote = useRecoilValue(clinicalNoteState);
  const user = useRecoilValue(user_state);
  const currentUserId = user?.user_id ?? user.id;

  const { data: documentSignatures } = useDocumentSign({
    params: {
      documentIds: [clinicalNote?.id],
      withRelations: { user: true }
    },
    dependencies: [clinicalNote?.id],
    options: {
      enabled: !!clinicalNote?.id,
      select: (response) => response.data
    }
  });

  const userAssignedToDocument = iaRa(documentSignatures).find(
    (row) => row?.user_id == currentUserId
  );

  const hasUserSigned = userAssignedToDocument?.status === 'signed';

  useEffect(() => {
    processDocumentSignInfo();
  }, [documentSignatures, clinicalNote?.id, saveButtonText]);

  const processDocumentSignInfo = () => {
    const userSign = userAssignedToDocument?.id ? hasUserSigned : clinicalNote?.locked;
    setUserSign(userSign);

    const signersLeft = iaRa(documentSignatures)
      ?.map((row) => `${row?.user?.f_name} ${row?.user?.l_name}`)
      .join(', ');

    const signLockButtonInfo = !clinicalNote?.id
      ? 'Clinical note has not started yet.'
      : saveButtonText === 'Saving'
        ? 'Please wait until the note is saved.'
        : !userAssignedToDocument?.id
          ? `You're not assigned to this document. The assigned providers are: ${signersLeft}`
          : null;

    setDocumentSignInfo({
      isUserAssignedToDocument: userAssignedToDocument,
      signLockButtonInfo,
      userSign
    });
  };

  return {
    userSign,
    userAssignedToDocument,
    documentSignatures
  };
};
export default useClinicalNoteSignatures;
